// extracted by mini-css-extract-plugin
export default {"container":"SmallLoader_container__LYyqZ","spinner":"SmallLoader_spinner__iIfhl","spinner-d3wgkg":"SmallLoader_spinner-d3wgkg__mTkCm"};